import { TDataTablePagination } from '../../components/Tables/DataTable'
import api, { getResponseError } from '../../services/api'
import {
  CollaboratorsPaginationProps,
  TCollaborator,
  TCollaboratorListPagination,
  TTenantAccount,
} from '../types/Collaborators'
import { IErrorResponse, TResponse } from '../types/ErrorResponse'

const getCollaborators = async ({
  page,
  rows,
  search,
}: CollaboratorsPaginationProps): Promise<
  TCollaboratorListPagination | IErrorResponse
> => {
  try {
    var path = `/UserAccountPermission?PageNumber=${page}&RowsPerPage=${rows}`

    if (search && search !== '') {
      path += `&Search=${search}`
    }

    const { status, data } =
      await api.get<TDataTablePagination<TCollaborator>>(path)
    if (status >= 200 && status <= 299) {
      return data
    }
    return {
      code: 1,
      error: 'Erro inesperado do servidor',
    }
  } catch (error) {
    const e = getResponseError(error)
    return {
      code: 2,
      error: e,
    }
  }
}

const getCollaborator = async ({
  codeId,
}: {
  codeId: string
}): Promise<TResponse<TCollaborator>> => {
  try {
    var path = `/UserAccountPermission/${codeId}`

    const { status, data } = await api.get<TCollaborator>(path)
    if (status >= 200 && status <= 299) {
      return {
        success: true,
        code: 0,
        error: '',
        data,
      }
    }
    return {
      success: false,
      code: 1,
      error: 'Erro inesperado do servidor',
    }
  } catch (error) {
    const e = getResponseError(error)
    return {
      success: false,
      code: 2,
      error: e,
    }
  }
}

const createCollaborator = async (body: {
  tenantOwnerId: string
  tenantAuthorizedEmail: string
  expiresAt?: Date | null
}): Promise<TResponse<string>> => {
  try {
    const { data } = await api.post('/UserAccountPermission', body)

    if (data) {
      return {
        success: true,
        code: 0,
        error: '',
        data,
      }
    }

    return {
      success: false,
      code: 1,
      error: 'Erro inesperado do servidor',
    }
  } catch (error) {
    const e = getResponseError(error)
    return {
      success: false,
      code: 2,
      error: e,
    }
  }
}

const deleteCollaborator = async ({
  codeId,
}: {
  codeId: string
}): Promise<TResponse<string>> => {
  try {
    const { status } = await api.delete(`/UserAccountPermission/${codeId}`)

    if (status >= 200 && status <= 299) {
      return {
        success: true,
        code: 0,
        error: '',
      }
    }

    return {
      success: false,
      code: 1,
      error: 'Erro inesperado do servidor',
    }
  } catch (error) {
    const e = getResponseError(error)
    return {
      success: false,
      code: 2,
      error: e,
    }
  }
}

const disableCollaborator = async ({
  codeId,
}: {
  codeId: string
}): Promise<TResponse<string>> => {
  try {
    const { status } = await api.put(`/UserAccountPermission/${codeId}/disable`)

    if (status >= 200 && status <= 299) {
      return {
        success: true,
        code: 0,
        error: '',
      }
    }

    return {
      success: false,
      code: 1,
      error: 'Erro inesperado do servidor',
    }
  } catch (error) {
    const e = getResponseError(error)
    return {
      success: false,
      code: 2,
      error: e,
    }
  }
}

const enableCollaborator = async ({
  codeId,
}: {
  codeId: string
}): Promise<TResponse<string>> => {
  try {
    const { status } = await api.put(`/UserAccountPermission/${codeId}/enable`)

    if (status >= 200 && status <= 299) {
      return {
        success: true,
        code: 0,
        error: '',
      }
    }

    return {
      success: false,
      code: 1,
      error: 'Erro inesperado do servidor',
    }
  } catch (error) {
    const e = getResponseError(error)
    return {
      success: false,
      code: 2,
      error: e,
    }
  }
}

const listAccountsByCollaborator = async (): Promise<
  TResponse<TTenantAccount[]>
> => {
  try {
    const { status, data } = await api.get<TTenantAccount[]>(
      `/UserAccountPermission/authorizations`
    )
    if (status >= 200 && status <= 299) {
      return {
        success: true,
        code: 0,
        error: '',
        data,
      }
    }
    return {
      success: false,
      code: 1,
      error: 'Erro inesperado do servidor',
    }
  } catch (error) {
    const e = getResponseError(error)
    return {
      success: false,
      code: 2,
      error: e,
    }
  }
}

const changeTenantAccountUser = async (body: {
  userAccountPermissionCodeId: string
}): Promise<TResponse<string>> => {
  try {
    const { status, data } = await api.post<string>(
      `/User/change/account`,
      body
    )
    if (status >= 200 && status <= 299) {
      return {
        success: true,
        code: 0,
        error: '',
        data,
      }
    }
    return {
      success: false,
      code: 1,
      error: 'Erro inesperado do servidor',
    }
  } catch (error) {
    const e = getResponseError(error)
    return {
      success: false,
      code: 2,
      error: e,
    }
  }
}

const UserAccountPermissionController = {
  getCollaborators,
  getCollaborator,
  createCollaborator,
  deleteCollaborator,
  listAccountsByCollaborator,
  changeTenantAccountUser,
  disableCollaborator,
  enableCollaborator,
}

export default UserAccountPermissionController
